import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";
//redux
import { useDispatch, useSelector } from "react-redux";
import { listOfComments } from '../../redux/comment/commentsAction'
import { articleDetail } from "../../redux/article/articalsActions";
//MUI
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Hidden from "@material-ui/core/Hidden";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
//MUI Icons
import TelegramIcon from "@material-ui/icons/Telegram";
import CommentIcon from "@material-ui/icons/Comment";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
//My Comment
import CommentArea from '../../components/Entities/Comment/CommentArea'
import WideLayout from "../../layouts/WideLayout";
import * as TokenBaseFunc from "../../globalFuncs/TokenBaseActions"
import * as TextLoader from "../../components/StaticTexts/Index";
import CommentAreaAdmin from '../../components/Entities/Comment/CommentAreaAdmin'

//consts
const numberLoader = [1, 2, 3, 4, 5, 6, 7, 8];
const numbers = [1, 2, 3, 4, 5, 6];

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
        padding: "10px auto",
    },
    textColorDark: {
        color: "#3B3B3B",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
    },
    grayBoxWithTitle: {
        backgroundColor: "#f2f2f2",
        marginTop: "-5px",
        borderRadius: "10px",
        padding: "45px 40px 40px 40px",
        [theme.breakpoints.down("xs")]: {
            padding: "45px 5px 40px 5px",
        },
    },
    green: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        width: "140px",
        "&:hover": {
            background: "#447557",
        },
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    formControl: {
        width: "100%",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        width: "39%",
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
        border: "1px #3d3d3d solid",
        height: "40px",
        marginTop: "0px",
        paddingRight: "10px !important",
        textAlign: "right !important",
    },
}));

const ArticleDetail = ({ lang, history, match }) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });
    let articleID = match.params.aid
    let articleTitle = (typeof match.params.title !== 'undefined') ? match.params.title.replace(/-/g, ' ') : ''
    const [staticText, setStaticText] = useState({})
    const [breadcrumbsItems, setBreadcrumbsItems] = useState([])
    const [categories, setCategories] = useState({})
    const articleDetails = useSelector((state) => state.articleDetails)
    const {
        loading,
        error,
        fullName,
        categoryId,
        date,
        imgURL,
        shortDescription,
        text,
        title,
    } = articleDetails;


    //Comments
    const [selectedCat, setSelectedCat] = useState(0)
    const [userInfo, setUserInfo] = useState([])
    const [loggedIn, setLoggedIn] = useState(false)
    const [itemID, setItemID] = useState(articleID)
    const commentsListState = useSelector(state => state.commentsList)
    const {
        cLoading,
        cError,
        comments,
        totalPages,
    } = commentsListState

    const refreshComment = () => {
        var il = TokenBaseFunc.TokenStatus()
        var ui = []
        if (il) {
            setLoggedIn(true)
            ui = TokenBaseFunc.ReturnUserInfos()
            setUserInfo(ui)
        }
        if (il) {
            dispatch(listOfComments(
                "article",
                itemID,
                1,
                ui.im,
                ui.token,
            ))
        }
        else {
            dispatch(listOfComments(
                "article",
                itemID,
                1,
                false,
                ''
            ))
        }
    }

    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    useEffect(() => {

        var isSharp = false
        if (window.location.hash) {
            isSharp = true
        }

        window.scrollTo(0, 0)
        var il = TokenBaseFunc.TokenStatus()
        var ui = []
        if (il) {
            setLoggedIn(true)
            ui = TokenBaseFunc.ReturnUserInfos()
            setUserInfo(ui)
        }


        if (lang === "fa") {
            setBreadcrumbsItems([
                {
                    title: "صفحه اصلی",
                    to: "/",
                },
                {
                    title: "مجله سلامت",
                    to: "/articels",
                },
                {
                    title: articleTitle,
                    to: "#",
                },
            ]);
        } else {
            setBreadcrumbsItems([
                {
                    title: "الصفحة الأصلية",
                    to: "/",
                },
                {
                    title: "مجلة الصحة",
                    to: "/articels",
                },
                {
                    title: title,
                    to: "#",
                },
            ]);
        }
        setStaticText(TextLoader.staticTextLoader("articleDetail", lang))
        dispatch(articleDetail(lang, articleID)).then(() => {
            setSelectedCat(categoryId)
        })


        if (il) {
            dispatch(listOfComments(
                "article",
                match.params.aid,
                1,
                ui.im,
                ui.token,
            ))
        }
        else {
            dispatch(listOfComments(
                "article",
                match.params.aid,
                1,
                false,
                ''
            ))
        }

    }, []);

    React.useEffect(async () => {
        const { data } = await axios.get(`/api/articles/getcategories?lan=fa`);
        if (data.status === "ok") {
            if (data.data.length > 0) {
                setCategories(data.data);
            }
        }
    }, []);

    return (
        <>
            <WideLayout lang={lang} breadcrumbsItems={breadcrumbsItems} title={!loading ? title + ' - مقالات - آجیل حسن پور' : ''}
                metas={!loading ? {
                    keywords: "",
                    description: shortDescription,
                    subject: "nuts",
                    copyright: 'Ajilhassanpour',
                    language: lang,
                    robots: "index,follow",
                    revised: date,
                    abstract: shortDescription,
                    topic: 'nuts',
                    summary: shortDescription,
                    Classification: 'article',
                    copyright: 'ajilhassanpour.com',
                    url: window.location.href,
                    directory: 'submission',
                    category: 'nuts',
                    coverage: 'Worldwide',
                    distribution: 'Global',
                    rating: 'General',
                    'og:title': title,
                    "og:type": 'article',
                    "og:url": window.location.href,
                    'og:image': imgURL,
                    'og:site_name': 'آجیل حسن پور',
                    'og:description': shortDescription
                } : null}>
                <Grid md={2} sm={12} xs={12}>
                    <Hidden only={["xs"]}>
                        <Grid item style={{ maxWidth: "100%" }} md={2} xs={12}>
                            <Paper width="100%" elevation={0}>
                                <Box elevation={1} boxShadow={0} p={1} m={0}>
                                    <div className="gray-box-with-title">
                                        <div className="title">{staticText.mainCatTitle}</div>
                                        <div className="content">

                                            <form>
                                                {(loading) &&
                                                    numbers.map(() => (
                                                        <>
                                                            <Skeleton
                                                                animation="wave"
                                                                height="30px"
                                                                width="80%"
                                                            />
                                                            <br />
                                                        </>
                                                    ))}
                                                {!loading && !error && typeof categories !== "undefined" && categories.length > 0 && (
                                                    <>
                                                        <RadioGroup
                                                            aria-label="mainCat"
                                                            name="mainCat"
                                                            value={(typeof selectedCat !== 'undefined') ? selectedCat.toString() : '0'}>
                                                            {categories.map((Category) => (
                                                                <FormControlLabel
                                                                    value={Category.id.toString()}
                                                                    control={
                                                                        <Radio
                                                                            onClick={() =>
                                                                                history.push(
                                                                                    `/articels/page/1/${Category.id}`
                                                                                )
                                                                            }
                                                                        />
                                                                    }
                                                                    label={Category.title}
                                                                    onClick={() =>
                                                                        history.push(
                                                                            `/articels/page/1/${Category.id}`
                                                                        )
                                                                    }
                                                                />
                                                            ))}
                                                        </RadioGroup>
                                                    </>
                                                )}
                                            </form>

                                        </div>
                                    </div>
                                </Box>
                            </Paper>
                        </Grid>
                    </Hidden>
                </Grid>
                <Grid md={10} sm={12} xs={12}>
                    <Paper elevation={0}>
                        <Hidden only={["md", "lg", "xl", "sm"]}>
                            <Box className="titleBox" style={{ width: '98%', margin: '0px auto' }} >
                                <h1>{title}</h1>
                            </Box>
                        </Hidden>
                        <Box
                            boxShadow={0}
                            border={0}
                            borderRadiusBottomLeft={10}
                            p={2}
                            m={1}
                            className={classes.grayBoxWithTitle}
                        >
                            <Grid container>
                                <Grid item md={5} sm={12} xs={12}>
                                    <Box mt={-3} p={1} textAlign="left">
                                        {loading ? (
                                            <Skeleton
                                                width="90%"
                                                height={300}
                                                style={{ borderRadius: "10px" }}
                                            />
                                        ) : (
                                            <img
                                                style={{ borderRadius: "10px" }}
                                                width="100%"
                                                position="relative"
                                                zIndex={999}
                                                src={imgURL}
                                            />
                                        )}
                                    </Box>
                                </Grid>
                                <Grid item md={7} sm={12} xs={12}>
                                    <Box pl={{ md: 60, sm: 2, xs: 1 }}>
                                        {loading ? (
                                            numbers.map(() => (
                                                <>
                                                    <Skeleton
                                                        variant="caption"
                                                        width={Math.random() * (101 - 30) + 30 + "%"}
                                                    />
                                                    <br />
                                                </>
                                            ))
                                        ) : (
                                            <>
                                                {" "}
                                                <Box
                                                    fontWeight="bold"
                                                    mt={4}
                                                    mb={1}
                                                    fontSize={35}
                                                    color="#272727"
                                                >
                                                    {title}
                                                </Box>
                                                <Box fontWeight="normal" fontSize={16} color="#2F2F2F">
                                                    {staticText.date} {" " + ":" + " "}
                                                    {date}
                                                </Box>
                                                <Box
                                                    fontWeight="normal"
                                                    mt={2}
                                                    fontSize={16}
                                                    color="#2F2F2F"
                                                >
                                                    {staticText.who} {" " + ":" + " "}
                                                    {fullName}
                                                </Box>
                                                <Box
                                                    fontWeight="normal"
                                                    mt={2}
                                                    fontSize={16}
                                                    color="#313131"
                                                >
                                                    <CommentIcon style={{ marginBottom: "-7px" }} />{" "}
                          &nbsp; 0
                        </Box>
                                            </>
                                        )}
                                    </Box>
                                </Grid>
                                <Grid xs={12}>
                                    <Box mt={6}>
                                        <h3>
                                            <b>{staticText.short}</b>
                                        </h3>
                                        <Box fontSize={16} color="#272727" p={1} mt={2}>
                                            {loading
                                                ? numberLoader.map(() => (
                                                    <>
                                                        <Skeleton
                                                            variant="caption"
                                                            width={Math.random() * (101 - 30) + 30 + "%"}
                                                        />
                                                        <br />
                                                    </>
                                                ))
                                                : <div style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: shortDescription }} />}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid xs={12}>
                                    <Box mt={6}>
                                        <h3>
                                            <b>{staticText.text}</b>
                                        </h3>

                                        <Box fontSize={16} color="#272727" mt={1} p={1}>
                                            {loading
                                                ? numberLoader.map(() => (
                                                    <>
                                                        <Skeleton
                                                            variant="caption"
                                                            width={Math.random() * (101 - 10) + 10 + "%"}
                                                        />
                                                        <br />
                                                    </>
                                                ))
                                                : <div style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: text }} />}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid xs={12}>
                                    <Box mt={9}>
                                        <h4>
                                            <b>{staticText.share}:</b>
                      &nbsp; &nbsp;
                      <span>
                                                <a
                                                    href={`http://twitter.com/home?status=${window.location.href}&amp;title=${title}`}
                                                    target="_blank"
                                                >
                                                    <TwitterIcon style={{ marginBottom: "-8px" }} />
                                                </a>{" "}
                        &nbsp; &nbsp;
                        <a
                                                    href={`https://telegram.me/share/url?text=${title}&url=${window.location.href}`}
                                                    target="_blank"
                                                >
                                                    <TelegramIcon style={{ marginBottom: "-8px" }} />
                                                </a>{" "}
                        &nbsp; &nbsp;
                        <a
                                                    href={`http://www.facebook.com/share.php?u=${window.location.href}&amp;t=${title}`}
                                                    target="_blank"
                                                >
                                                    <FacebookIcon style={{ marginBottom: "-8px" }} />
                                                </a>{" "}
                        &nbsp; &nbsp;
                      </span>
                                        </h4>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
                {(!cLoading && typeof comments !== "undefined") ? (
                    (userInfo.length !== 0) ? (
                        (userInfo.im) ? (
                            <CommentAreaAdmin cLoading={cLoading} cError={cError} comments={comments} refFunc={refreshComment} totalPages={totalPages} loggedIn={loggedIn} userInfo={userInfo} itemId={itemID} typeOfEntities="article" showStar={true} btnSendText='ثبت نظر و امتیاز' />
                        ) : (
                            <CommentArea cLoading={cLoading} cError={cError} comments={comments} totalPages={totalPages} loggedIn={loggedIn} userInfo={userInfo} itemId={itemID} typeOfEntities="article" showStar={true} btnSendText='ثبت نظر و امتیاز' />
                        )
                    ) : (
                        <CommentArea cLoading={cLoading} cError={cError} comments={comments} totalPages={totalPages} loggedIn={loggedIn} userInfo={userInfo} itemId={itemID} typeOfEntities="article" showStar={true} btnSendText='ثبت نظر و امتیاز' />
                    )
                ) : (
                    <>
                    </>
                )}
                <Snackbar
                    open={alert.open}
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={toggleCloseAlert}>
                    <Alert onClose={toggleCloseAlert} severity={alert.type}>
                        {alert.message}
                    </Alert>
                </Snackbar>

            </WideLayout>
        </>
    );
};

ArticleDetail.propTypes = {
    lang: PropTypes.string,
};

export default ArticleDetail;
